
export  const NAV_MENU_ITEMS = [
  {
    displayName: "Products",
    url: "products",
    disabled:false
  },
  {
    displayName: "NAV & IDCW",
    url: "nav-dividends",
    disabled:false
  },
  {
    displayName: "Contact Us",
    url: "contact",
    disabled:false
  },
  {
    displayName: "About Us",
    url: "about",
    disabled:false
  },
  {
    displayName: "Investors",
    url: "investors",
    disabled:false
  },
  {
    displayName: "Partners",
    url: "distributor",
    disabled:false
  },
  {
    displayName: "Downloads",
    url: "downloads",
    disabled:false
  },
  {
    displayName: "Statutory Disclosure",
    url: "statuory-disclosure",
    disabled:false
  },
  {
    displayName: "NFO",
    url: "nfo",
    disabled:false
  },
  {
    displayName: "CIO's Desk",
    url: "cio-desk",
    disabled:false
  },
  {
    displayName: "Latest News",
    url: "latest-news",
    disabled:false
  },
    {
    displayName: "Knowledge Center",
    url: "knowledge",
    disabled:false
  },
  {
    displayName: "Investor Education",
    url: "blogs",
    disabled:false
  }
]
